export function searchResultId(result) {
  return `map-search-result-${result.mapId || 'local'}-${result.node.id}`;
}

export function mergeSearchResults(local, remote, mapId, nodes, mapTitle) {
  const visibleNodes = new Map(nodes.map(node => [node.id, node]));
  const results = local.map(result => ({ ...result, mapId, mapTitle, kind: 'idea' }));
  const seen = new Set(results.map(result => `${result.mapId}:${result.node.id}`));
  for (const result of remote) {
    const key = `${result.mapId}:${result.nodeId}`;
    if (seen.has(key)) continue;
    // Keep the current live graph authoritative over a delayed persisted copy.
    if (result.mapId === mapId && (!visibleNodes.has(result.nodeId) || result.kind !== 'document')) continue;
    seen.add(key);
    results.push({ ...result, node: result.mapId === mapId
      ? visibleNodes.get(result.nodeId) : { id: result.nodeId } });
  }
  return results;
}

export function buildSearchDestination(result, location = window.location) {
  // Start clean: never carry the source map's share/invitation fragment or
  // other query parameters into a different map.
  const url = new URL(location.pathname, location.origin);
  url.searchParams.set('map', result.mapId);
  url.searchParams.set('node', result.node.id);
  return url.toString();
}

export function navigateSearchResult(result, { currentMapId, reveal, notify, open, location }) {
  if (typeof result === 'string' || !result?.mapId || result.mapId === currentMapId) {
    reveal(typeof result === 'string' ? result : result.node.id);
    return false;
  }
  notify(`Opening “${result.mapTitle}” in a new tab. Your current map stays open.`, 'info');
  open(buildSearchDestination(result, location), '_blank', 'noopener,noreferrer');
  return true;
}
